import type { FunctionComponent } from 'react';
import { Button, Link } from '@dr.pogodin/react-utils';

import Logo from 'assets/images/logo-soul-sanctuary-new-150px.svg';

import h52ButtonTheme from 'themes/Button/h52px.scss';

import './style.scss';

const LandingPage: FunctionComponent = () => (
  <div styleName="container">
    <div styleName="content">
      <Logo styleName="logoLogin" />
      <div styleName="mainContent">
        <Button
          theme={h52ButtonTheme}
          to="/register"
        >
          Get Started
        </Button>
        <div styleName="text">
          Have an account already? &zwnj;
          <Link styleName="link" to="/login">
            Log In
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default LandingPage;
